'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    name: 'shrink',
    shape: _react2.default.createElement(
        'g',
        null,
        _react2.default.createElement('polygon', { points: '0,29.172 2.828,32 7.414,27.414 12,32 12,20 0,20 4.586,24.586' }),
        _react2.default.createElement('polygon', { points: '20,12 32,12 27.414,7.414 31.961,2.871 29.133,0.043 24.586,4.586 20,0' })
    ),
    viewbox: '0 0 32 32',
    label: 'Shrink'
};
//# sourceMappingURL=shrink.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/ui-svg/lib/cjs/icons/shrink.js
 ** module id = 693
 ** module chunks = 1
 **/